import React, { useState } from "react";
import Eventscard from './Eventscard';

// Helper component to render event section
const EventSection = ({ 
    title, 
    details, 
    showAll, 
    onToggleShowAll, 
    shouldShowButton, 
    shouldRenderSection,
    page 
}) => {
    if (!shouldRenderSection) {
        return null;
    }

    const eventsToDisplay = showAll ? details : details.slice(0, 3);

    return (
        <>
            <div className="row justify-content-between align-items-center">
                <div className="col">
                    <p className="Events_day">{title}</p>
                </div>
                {shouldShowButton && (
                    <div className="col d-flex justify-content-end">
                        <button className="see-all-btn btn" onClick={onToggleShowAll}>
                            See All
                        </button>
                    </div>
                )}
            </div>
            <div className="row">
                {eventsToDisplay.map((usp, index) => (
                    <Eventscard key={index} storeData={usp} page={page} />
                ))}
            </div>
        </>
    );
};

// Helper function to determine event title
const getEventTitle = (details, singularLabel, pluralLabel) => {
    if (!details || details.length === 0) {
        return singularLabel;
    }
    return details.length <= 1 ? singularLabel : pluralLabel;
};

const Eventslist = (props) => {
    const { 
        upcomingDetails,
        todayDetails,
        todayallDetails,
        todayallbtn,
        tomorrowDetails,
        tomorrowallDetails,
        pastDetails,
        pastallDetails,
        pastallbtn,
        tomorrowallbtn,
        upcomingallDetails,
        upcomingallbtn 
    } = props;
    
    const [isONtodayall, setIsONtodayall] = useState(false);
    const [isONtomorrowall, setIsONtomorrowall] = useState(false);
    const [isONupcomingall, setIsONupcomingall] = useState(false);
    const [isONpastall, setIsONPastall] = useState(false);

    return (
        <React.Fragment>
            <div className="usp_main">
                <div className="container-lg">
                    <EventSection
                        title={getEventTitle(todayDetails, "Today Event", "Today's Events")}
                        details={todayDetails}
                        showAll={isONtodayall}
                        onToggleShowAll={() => setIsONtodayall(!isONtodayall)}
                        shouldShowButton={!todayallbtn}
                        shouldRenderSection={todayallDetails}
                    />

                    <EventSection
                        title={getEventTitle(tomorrowDetails, "Tomorrow Event", "Tomorrow's Events")}
                        details={tomorrowDetails}
                        showAll={isONtomorrowall}
                        onToggleShowAll={() => setIsONtomorrowall(!isONtomorrowall)}
                        shouldShowButton={!tomorrowallbtn}
                        shouldRenderSection={tomorrowallDetails}
                    />

                    <EventSection
                        title="Upcoming Events"
                        details={upcomingDetails}
                        showAll={isONupcomingall}
                        onToggleShowAll={() => setIsONupcomingall(!isONupcomingall)}
                        shouldShowButton={!upcomingallbtn}
                        shouldRenderSection={upcomingallDetails}
                    />

                    <EventSection
                        title={getEventTitle(pastDetails, "Past Event", "Past Events")}
                        details={pastDetails}
                        showAll={isONpastall}
                        onToggleShowAll={() => setIsONPastall(!isONpastall)}
                        shouldShowButton={!pastallbtn}
                        shouldRenderSection={pastallDetails}
                        page="past"
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

export default Eventslist;
